import { render } from "./gmAbnormalNumber.vue?vue&type=template&id=c7fa9bba&scoped=true"
import script from "./gmAbnormalNumber.vue?vue&type=script&lang=js"
export * from "./gmAbnormalNumber.vue?vue&type=script&lang=js"

import "./gmAbnormalNumber.vue?vue&type=style&index=0&id=c7fa9bba&scoped=true&lang=css"
import "./gmAbnormalNumber.vue?vue&type=style&index=1&id=c7fa9bba&lang=css"
script.render = render
script.__scopeId = "data-v-c7fa9bba"

export default script